import type { TreeTag } from '#domains/tags/types';
import type {
  OptimisticCreatePayload,
  OptimisticDeletePayload,
  OptimisticEditPayload,
  ToggleOpenPayload
} from './actions';
import {
  optimisticCreate,
  optimisticDelete,
  optimisticEdit,
  toggleOpen
} from './actions';
import type { Action } from './types';

const dispatch = (state: TreeTag[], action: Action) => {
  if (action.type === 'OPTIMISTIC_CREATE') {
    return optimisticCreate(state, action.payload as OptimisticCreatePayload);
  }

  if (action.type === 'OPTIMISTIC_DELETE') {
    return optimisticDelete(state, action.payload as OptimisticDeletePayload);
  }

  if (action.type === 'OPTIMISTIC_EDIT') {
    return optimisticEdit(state, action.payload as OptimisticEditPayload);
  }

  if (action.type === 'TOGGLE_OPEN_STATE') {
    return toggleOpen(state, action.payload as ToggleOpenPayload);
  }

  return state;
};

export default dispatch;
